import { render, staticRenderFns } from "./item-drawer.vue?vue&type=template&id=7e4d8334&"
import script from "./item-drawer.vue?vue&type=script&lang=js&"
export * from "./item-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports